import { render, staticRenderFns } from "./IconRedDot.vue?vue&type=template&id=3f173896&functional=true&"
import script from "./IconRedDot.vue?vue&type=script&lang=js&"
export * from "./IconRedDot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports